import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';

import { ValueFormatter } from '../../types.js';

export const dollarAndCents: ValueFormatter = (price: AloftPrice | undefined) => {
  if (isUndefined(price)) {
    return { str: [''] };
  }

  if (!AloftPrice.isAloftPrice(price)) {
    throw Error(`Invalid price: ${JSON.stringify(price)}`);
  }

  return { str: [price.toString()] };
};
